import { ReportStatusEnum } from 'src/slices/services/api'
import { PreFinalizeCsvExportableStatus } from './reportStatus'

// パルコ向けCSVの金額列の定義 (Epic #3094 要件3 / Issue #3454)
//
// - header: CSV上の表記。calculation_itemの「純売上（税抜）」はCSV上「売上高」と表示する
// - sendParameterName: 送信パラメータ名。これで対象の算出項目を同定する
//
// NOTE: 項目名（日本語）ではなく sendParameterName で識別する。DSL編集による表記ゆれに強く、
//       src/domain/calculationItem.ts（MITSUI_VISIBLE_SEND_PARAMS）と同じ方式に揃えている。
// NOTE: パルコorg(013)の算出項目は send_parameter_name が parco_param0〜3 で、
//       parco_param0=客数 / parco_param1=純売上（税抜）/ parco_param2=商品券（現物合計額）/
//       parco_param3=本日納金額。parco_param2 は要件(3)の9列に含まれないため出力しない。
export type ParcoCsvItemColumn = {
  header: string
  sendParameterName: string
}

export const PARCO_CSV_ITEM_COLUMNS: ParcoCsvItemColumn[] = [
  { header: '売上高', sendParameterName: 'parco_param1' },
  { header: '客数', sendParameterName: 'parco_param0' },
  { header: '本日納金額', sendParameterName: 'parco_param3' },
]

// CSVの「ステータス」列に出力する文言。
// UIバッジ用の reportStatusMap とは分離する: あちらは画面表示のコピーで、
// こちらはパルコ側がパースする納品ファイルの契約のため、文言変更の影響範囲が異なる。
// 出力対象は確定前(報告済み・再送済み)のみ (Issue #3408)。
//
// NOTE: キーの型は reportStatus.ts と共有しており、出力対象を増減させると
//       ここが型エラーになる（文言の付け忘れによる空欄出力を型で防ぐ）。
//       非公開なのは、表を直接引くと下のフォールバックを素通りできるため。
const PARCO_CSV_STATUS_LABELS: Record<PreFinalizeCsvExportableStatus, string> =
  {
    [ReportStatusEnum.Reported]: '報告済み',
    [ReportStatusEnum.ImageResent]: '再送済み',
  }

const isExportableStatus = (
  status: ReportStatusEnum
): status is PreFinalizeCsvExportableStatus => status in PARCO_CSV_STATUS_LABELS

// CSVの「ステータス」列の値を解決する。
// 出力対象外のステータスは呼び出し前に isCsvExportable で除外済みだが、
// APIの戻り値型では表現しきれないため、万一到達しても納品ファイルに
// "undefined" を出さないよう空文字に落とす。
export const parcoCsvStatusLabel = (status: ReportStatusEnum): string =>
  isExportableStatus(status) ? PARCO_CSV_STATUS_LABELS[status] : ''

// パルコCSVのヘッダー行（要件(3)で指定された9列）
export const PARCO_CSV_HEADERS = [
  'ステータス',
  '売上日',
  '店舗コード',
  '店舗名',
  'テナントコード',
  'テナント名',
  ...PARCO_CSV_ITEM_COLUMNS.map((column) => column.header),
]
